"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDept = exports.getDeptTreeList = exports.deleteDeptById = exports.addDept = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加部门表
 * @param dept
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addDept = exports.addDept = function addDept(dept) {
  return _api.default.request({
    url: '/system/dept/save',
    method: 'post',
    data: dept
  });
};

/**
 * 修改部门表
 * @param dept
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateDept = exports.updateDept = function updateDept(dept) {
  return _api.default.request({
    url: '/system/dept/update',
    method: 'post',
    data: dept
  });
};

/**
 * 删除部门表
 * @param deptId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteDeptById = exports.deleteDeptById = function deleteDeptById(deptId) {
  return _api.default.request({
    url: '/system/dept/delete',
    method: 'post',
    params: {
      id: deptId
    }
  });
};

/**
 * 获取tree数据
 * @param deptId
 * @returns {AxiosPromise}
 */
var getDeptTreeList = exports.getDeptTreeList = function getDeptTreeList() {
  return _api.default.request({
    url: '/system/dept/getDeptTreeList',
    method: 'get'
  });
};